import request from '@/utils/request'

// 类型表

let CustomFieldApi = {

    /*列表*/
    getList(data, errorback) {
        return request._post('/shop/study.custom_field/index', data, errorback);
    },

    /*添加*/
    add(data, errorback) {
        return request._post('/shop/study.custom_field/add', data, errorback);
    },

    /*删除*/
    del(data, errorback) {
        return request._post('/shop/study.custom_field/del', data, errorback);
    },

    /*编辑*/
    edit(data, errorback) {
        return request._post('/shop/study.custom_field/edit', data, errorback);
    },

    /*批量*/
    batch(data, errorback) {
        return request._post('/shop/study.custom_field/batch', data, errorback);
    },
}

export default CustomFieldApi;



// WEBPACK FOOTER //
// ./src/api/study/custom_field.js